export default "__VITE_ASSET__C9CW6E0M__"